import axios from 'axios'
import {
  commonParams
} from 'common/config/config'
// import Vue from 'vue'
// import * as Uloading from 'common/js/UDialog'
import UAccoutService from 'common/js/UAccoutService'
import { getPlatform } from '../utils/platform'

import {
  exitApp,
  loggedOnOtherDevices
} from 'common/js/mobilePlugin'

import cookies from 'js-cookie'

// import { getPlatform } from 'common/utils/platform'

let Authorization = UAccoutService.getToken() || cookies.get('AUTHORIZATION')


let headerauthorJSON = {
  'AUTHORIZATION': Authorization
}
export function creatHttpTool() {
  // Authorization = Authorization || UAccoutService.getToken()

  headerauthorJSON = {
    'AUTHORIZATION': Authorization
  }
  return {
    get: function (url) {
      let host = `${commonParams.CONFIG_API_HOST}${url}`
      headerauthorJSON = this.getHttpToken()
      return new Promise(function (resolve, reject) {
        axios.get(host, {
          headers: headerauthorJSON
        }).then(function (res) {
          handelSuccess(res, resolve, reject)
        }, function (err) {
          handelFailure(err, reject)
        })
      })
    },
    post: function (url, params) {
      let host = `${commonParams.CONFIG_API_HOST}${url}`
      headerauthorJSON = this.getHttpToken()
      return new Promise(function (resolve, reject) {
        axios.post(host, params, {
          headers: headerauthorJSON
        }).then(function (res) {
          handelSuccess(res, resolve, reject)
        }, function (err) {
          handelFailure(err, reject)
        })
      })
    },
    delete: function (url) {
      let host = `${commonParams.CONFIG_API_HOST}${url}`
      headerauthorJSON = this.getHttpToken()
      return new Promise(function (resolve, reject) {
        axios.delete(host, {
          headers: headerauthorJSON
        }).then(function (res) {
          handelSuccess(res, resolve, reject)
        }, function (err) {
          handelFailure(err, reject)
        })
      })
    },
    getOwn: function (url) {
      let host = `${url}`
      let token = UAccoutService.getToken() || cookies.get('AUTHORIZATION')
      let REVIEW_TEACHERID = cookies.get('REVIEW_TEACHERID')
      let tokenJSON = {
        'AUTHORIZATION': token
      } 
      if (token == 'REVIEW_TEACHER_TOKEN' && REVIEW_TEACHERID) {
        tokenJSON = {
          'AUTHORIZATION': token,
          'REVIEW_TEACHERID': REVIEW_TEACHERID,
        }
      }

      return new Promise(function (resolve, reject) {
        axios.get(host, {
          headers: tokenJSON
        }).then(function (res) {
          handelCustomSuccess(res, resolve, reject)
        }, function (err) {
          handelCustomFailure(err, reject)
        })
      })
    },
    getToken: function () {
      let host = commonParams.UPBASETORKEN_URL + '/object/token'
      return new Promise(function (resolve, reject) {
        axios.get(host, {
          responseType: 'text'
        }).then(function (res) {
          handelCustomSuccess(res, resolve, reject)
        }, function (err) {
          handelCustomFailure(err, reject)
        })
      })
    },
    getUpToken: function (url) {
      let host = url
      return new Promise(function (resolve, reject) {
        axios.get(host).then(function (res) {
          handelCustomSuccess(res, resolve, reject)
        }, function (err) {
          handelCustomFailure(err, reject)
        })
      })
    },
    convertFile: function (url) {
      return new Promise(function (resolve, reject) {
        axios.get(url).then(function (res) {
          handelCustomSuccess(res, resolve, reject)
        }, function (err) {
          handelCustomFailure(err, reject)
        })
      })
    },
    getHttpToken: function () {
      let token = cookies.get('AUTHORIZATION')
      let REVIEW_TEACHERID = cookies.get('REVIEW_TEACHERID')
      const lang = window.getLang()

      if ((REVIEW_TEACHERID == 'REVIEW_TEACHER_TOKEN' || token == 'REVIEW_TEACHER_TOKEN') && REVIEW_TEACHERID) {
        return {
          'AUTHORIZATION': UAccoutService.getToken() || token || 'B47981C382F557380CF9CFCED0FFD517',
          'REVIEW_TEACHERID': REVIEW_TEACHERID,
          'Accept-Language': lang
        }
      } else {
        return {
          'AUTHORIZATION': UAccoutService.getToken() || token || 'B47981C382F557380CF9CFCED0FFD517',
          'Accept-Language': lang
        }
      }

    }
  }
}

let instance = axios.create()

export function creatCustomHttpTool() {
  Authorization = Authorization || UAccoutService.getToken()

  headerauthorJSON = {
    'AUTHORIZATION': Authorization
  }
  return {
    post: function (url, headerJSON, params) {
      let host = `${url}`
      return new Promise(function (resolve, reject) {
        instance.post(host, params, {
          headers: headerJSON
        }).then(function (res) {
          handelCustomSuccess(res, resolve, reject)
        }, function (err) {
          handelCustomFailure(err, reject)
        })
      })
    },
    get: function (url, headerJSON, params) {
      let host = `${url}`
      headerauthorJSON = this.getHttpToken()
      return new Promise(function (resolve, reject) {
        instance.get(host,{
          headers: headerJSON || headerauthorJSON
        }).then(function (res) {
          handelCustomSuccess(res, resolve, reject)
        }, function (err) {
          handelCustomFailure(err, reject)
        })
      })
    },
    getHttpToken: function () {
      let token = cookies.get('AUTHORIZATION')
      let REVIEW_TEACHERID = cookies.get('REVIEW_TEACHERID')
      const lang = window.getLang()

      if ((REVIEW_TEACHERID == 'REVIEW_TEACHER_TOKEN' || token == 'REVIEW_TEACHER_TOKEN') && REVIEW_TEACHERID) {
        return {
          'AUTHORIZATION': UAccoutService.getToken() || token || 'B47981C382F557380CF9CFCED0FFD517',
          'REVIEW_TEACHERID': REVIEW_TEACHERID,
          'Accept-Language': lang
        }
      } else {
        return {
          'AUTHORIZATION': UAccoutService.getToken() || token || 'B47981C382F557380CF9CFCED0FFD517',
          'Accept-Language': lang
        }
      }

    }
  }
}

export function creatCustomHttpToolData() {
  Authorization = Authorization || UAccoutService.getToken()

  headerauthorJSON = {
    'AUTHORIZATION': Authorization
  }
  return {
    post: function (url, headerJSON, params) {
      let host = `${url}`
      headerauthorJSON = this.getHttpToken()
      return new Promise(function (resolve, reject) {
        instance.post(host, params, {
          headers: headerauthorJSON
        }).then(function (res) {
          handelCustomSuccessData(res, resolve, reject)
        }, function (err) {
          handelCustomFailure(err, reject)
        })
      })
    },
    get: function (url, headerJSON, params) {
      let host = `${url}`
      headerauthorJSON = this.getHttpToken()
      return new Promise(function (resolve, reject) {
        instance.get(host,{
          headers: headerauthorJSON
        }).then(function (res) {
          handelCustomSuccessData(res, resolve, reject)
        }, function (err) {
          handelCustomFailure(err, reject)
        })
      })
    },
    getHttpToken: function () {
      let token = cookies.get('AUTHORIZATION')
      let REVIEW_TEACHERID = cookies.get('REVIEW_TEACHERID')
      const lang = window.getLang()

      if ((REVIEW_TEACHERID == 'REVIEW_TEACHER_TOKEN' || token == 'REVIEW_TEACHER_TOKEN') && REVIEW_TEACHERID) {
        return {
          'AUTHORIZATION': UAccoutService.getToken() || token || 'B47981C382F557380CF9CFCED0FFD517',
          'REVIEW_TEACHERID': REVIEW_TEACHERID,
          'Accept-Language': lang
        }
      } else {
        return {
          'AUTHORIZATION': UAccoutService.getToken() || token || 'B47981C382F557380CF9CFCED0FFD517',
          'Accept-Language': lang
        }
      }
    }
  }
}

function handelLogout(err) {
  if (err && err.response) {
    switch (err.response.status) {
      case 401:
        if (getPlatform().isInApp) {
          try {
            let token = UAccoutService.getToken() || cookies.get('AUTHORIZATION')
            if (err.response.data.code == 2301 ) {
              if (token) {
                loggedOnOtherDevices(token, function success() {
                  // alert(token+'httpTool')
                }, function fail() {
                  alert('已在其他终端登录!')
                })
                UAccoutService.setAccount({token: null})
                cookies.set('AUTHORIZATION',null)
                setTimeout(function () {
                  exitApp()
                }, 1000)
              }
            }
            if (!window.isReLoging && (err.response.data.code == 2001 || err.response.data.code == 2101 || err.response.data.code == 2201)) {
              window.isReLoging = true
              if (window.ULplugin && window.ULplugin.User) {
                window.ULplugin.User.reLogin()
                exitApp()
              }
            }
            
          } catch (err) {}
        } else {
          if (
            err.response.data.code == 2001 ||
            err.response.data.code == 2101 ||
            err.response.data.code == 2201
          ) {
            // showMessage('token过期', 'error')
            window.location = `https://www${commonParams.UMOOC_COOKIE_DOMAIN}/ulearning/tip/timeout.html`;
          }
        }
        
        break
      default:
        break
    }
  }
}

function handelSuccess(res, resolve, reject) {
  if (!res) {
    reject && reject(res.message)
    return
  }
  if (res.data.code === 1) {
    resolve && resolve(res.data.result)
  } else {
    reject && reject(res.data.message)
  }
}

function handelCustomSuccess(res, resolve, reject) {
  if (!res) {
    reject && reject(res)
    // if (res.message === 'Network Error') {
    //   // Uloading.showToast(new Vue(), {content: 'token失效'})
    //   Uloading.showToastAutoHide(new Vue(), {duration: 5000, type: 'error', content: 'token失效'})
    //   return false
    // }
    return false
  }
  resolve && resolve(res.data)
}

function handelCustomSuccessData(res, resolve, reject) {
  resolve && resolve(res)
}

function handelFailure(err, reject) {
  // if (err.message === 'Network Error') {
  //   Uloading.showToastAutoHide(new Vue(), {duration: 5000, type: 'error', content: 'token失效'})
  //   return false
  // }
  handelLogout(err)
  reject && reject(err)
}

function handelCustomFailure(err, reject) {
  handelLogout(err)
  reject && reject(err)
}



// WEBPACK FOOTER //
// ./src/common/js/httpTool.js